<template>
  <Modal v-model="model" :title="title" @on-cancel="cancel" sticky reset-drag-position footer-hide scrollable :mask="false" draggable class="insert_edit_pop knowledgeCategory_pop"  width="800">
    <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <div id="setting_knowledge_panel" style="overflow-y: scroll; width: 968px; height: 493px;" title class="panel-body panel-body-noborder window-body">
      <div style="height: 100%;background: #eeeeee">
        <table>
          <tr valign="top">
            <td style="width:6%"></td>
            <td style="width:40%">
              <div class="tree_pop_div">
                <div class="ztree" id="knowledgeTreePop"></div>
              </div>
            </td>
            <td style="width:1%"></td>
            <td style="width:50%">
              <div id="action_knowledge" style="height: auto; padding-left: 10px; margin: 10px; width: 400px;" class="tabs-container">
                <template>
                  <Tabs size="small">
                    <Tab-pane label="添加类目" v-if="roleList['6_2-3']">
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="font_style_set">上级类目:</div>
                          <div class="insert_edit_input">
                            <Select v-model="selectedTreeId" disabled  placeholder="根类目" clearable>
                              <Option v-for="(option, index) in pidList"  :value="option.id" :key="index">{{option.name}}</Option>
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="font_style_set">类目标题:</div>
                          <div class="insert_edit_input">
                            <Input v-model="nameForAdd" placeholder="请输入标题"/>
                          </div>
                        </div>
                      </div>
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="insert_edit_input" style="text-align: center;">
                            <Button type="primary" class="submit_btn" @click="save()">添加</Button>
                          </div>
                        </div>
                      </div>
                    </Tab-pane>
                    <Tab-pane label="编辑类目" v-if="roleList['6_2-1']">
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="font_style_set">当前类目:</div>
                          <div class="insert_edit_input">
                            <Select v-model="selectedTreeId" disabled placeholder="根类目" clearable>
                              <Option v-for="(option, index) in pidList" :value="option.id" :key="index">{{option.name}}</Option>
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="font_style_set">修改类目:</div>
                          <div class="insert_edit_input">
                            <Input v-model="name" placeholder="请输入标题"/>
                          </div>
                        </div>
                      </div>
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="insert_edit_input" style="text-align: center;">
                            <Button type="primary" class="submit_btn" @click="edit()">修改</Button>
                          </div>
                        </div>
                      </div>
                    </Tab-pane>
                    <Tab-pane label="删除类目" v-if="roleList['6_2-2']">
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="font_style_set">当前类目:</div>
                          <div class="insert_edit_input">
                            <Select v-model="selectedTreeId" disabled placeholder="根类目" clearable>
                              <Option v-for="(option, index) in pidList" :value="option.id" :key="index">{{option.name}}</Option>
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="insert_edit_input" style="text-align: center;">
                            <Button type="primary" class="delete_btn" @click="deleteKnLg()">删除</Button>
                          </div>
                        </div>
                      </div>
                    </Tab-pane>
                  </Tabs>
                </template>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "KnowledgeCategoryPop",
    mixins:[publicFunClass],
    props: {
      showCategoryEdit:Boolean,
    },
    data(){
      return {
        inspectTreeDataTwo:[],
        selectedTreeId:'0',
        selectedTreeName:'',
        model:false,
        spinShow:true,
        roleList:JSON.parse(localStorage.getItem("roleList")),
        selected:true,
        showMessage:false,
        journalType:'',
        menuId:'',
        pid:'',
        name:'',
        nameForAdd:'',
        remark:'',
        isOpen:'',
        pidList:[],
        currentChildrenList:[],
        title:'知识分类',
        selectTreePid:'',
        modelHeight:{'maxHeight':'','marginTop':'20px'},
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        }
    },
    methods:{
      checkRepeat:function(newName){
        for (let i=0;i<this.currentChildrenList.length;i++){
          let name=this.currentChildrenList[i].name;
          if(newName==name){
            this.$alert("同一级目录下名称不能重复", '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
        }
        return true;
      },
      cancel:function(){
        this.$emit("closeCategoryKnlgPop",true);
      },
      save:function () {
        if(!this.nameForAdd){
          this.$Modal.info({
            title:'提示',
            content:"类目标题不能为空"
          });
          return false;
        }
        if(!this.selectedTreeId){
          this.selectedTreeId="0";
        }
        let check=this.checkRepeat(this.nameForAdd);
        if(!check){
          return false;
        }
        let param= {
          journalType:"知识库管理=>知识总览=>添加类目",
          menuId:"6_2-3",
          pid:this.selectedTreeId,
          name:this.nameForAdd,
        };
        let that=this;
        that.$http.post("knowledge/doLevelSave.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.$Message.info("保存成功");
          that.refreshNode();
          that.initSearchTree();
          // that.searchBaseName();
          that.nameForAdd="";
          that.name="";
        });
      },
    refreshNode:function() {
    let zTree = $.fn.zTree.getZTreeObj("knowledgeTreePop"),
      type = "refresh",
      silent = false,
      nodes = zTree.getSelectedNodes();
      zTree.reAsyncChildNodes(nodes[0], type, silent);
    },
    edit:function(){
        if("0"==this.selectedTreeId || !this.selectedTreeId){
          this.$Modal.info({
            title:'提示',
            content:"根目录不能修改"
          });
          return false;
        }
        if(this.name==""){
          this.$Modal.info({
            title:'提示',
            content:"标题不能为空"
          });
          return false;
        }
        let param={
          journalType:"知识库管理=>知识总览=>编辑类目",
          menuId:"6_2-1",
          id:this.selectedTreeId,
          pid:this.selectTreePid,
          name:this.name,
        }
        let that=this;
        that.$http.post("knowledge/doLevelSave.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.$Message.info("操作成功");
          that.initSearchTree();
          // that.searchBaseName();
        });
      },
      deleteKnLg:function(){

        if("0"==this.selectedTreeId || !this.selectedTreeId){
          this.$Modal.info({
            title:'提示',
            content:"根目录不能删除"
          });
          return false;
        }
        let param={
          journalType:"知识库管理=>知识总览=>删除类目",
          menuId:"6_2-2",
          id:this.selectedTreeId,
          type:'0',
        };
        let that=this;
        that.$Modal.confirm({
          title: '提示',
          content: "是否确定删除",
          onOk: () => {
            that.$http.post("knowledge/doDelete.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定'
                });
                return false;
              }
              that.$Message.info("操作成功");
              that.initSearchTree();
              // that.searchBaseName();
            });
          }
        });
      },
      initSearchTree:function () {
        this.spinShow=true;
        let that=this;
        let paramTwo={
          name:"根类目",
          pid : "null",
          id : "0",
          open:true,
        };
        let param={
          type:"0",
          journalType:"null",
          menuId:"null"
        };
        that.$http.post("knowledge/toLevelIndex.json",param) .then(function (res) {
          that.spinShow=false;
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.inspectTreeDataTwo=res.data.obj.tree;
          that.inspectTreeDataTwo.push(paramTwo);
          that.initKnowledgeTree();
          that.searchBaseName(res.data.obj.tree);
        });
      },
      //设备树初始化
      initKnowledgeTree:function () {
        let that=this;
        let setting = {
          view: {
            dblClickExpand: false,
            showLine: true,
            selectedMulti: false
          },
          data: {
            simpleData: {
              enable:true,
              idKey: "id",
              pIdKey: "pid",
              rootPId: ""
            }
          },
          callback: {
            onClick: zTreeOnClick
          }
        };
        function zTreeOnClick(event,treeId,treeNode) {
          that.selectedTreeId=treeNode.id;
          that.selectTreePid = treeNode.pid;
          that.currentChildrenList=[];
          if(treeNode.children){
            that.currentChildrenList=treeNode.children;
          }
          that.name="";
          that.nameForAdd="";
        }
        let zNodes =that.inspectTreeDataTwo;
        if (zNodes){
          $(document).ready(function(){
            $.fn.zTree.init($("#knowledgeTreePop"), setting, zNodes);//t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
          });
        }
      },
      searchBaseName(treeData){
        this.currentChildrenList=[];
        let list=treeData;
        this.pidList=list;
        for (let i=0;i<list.length;i++){
          let pid=list[i].pid;
          if(pid=="0"){
            let param={
              name:list[i].name
            };
            this.currentChildrenList.push(param);
          }
        }
      },
    },
    created(){
    },
    watch:{
      showCategoryEdit:function () {
        this.model=this.showCategoryEdit;
        this.selectedTreeId="0";
        this.name="";
        this.nameForAdd="";
        if(this.showCategoryEdit){
          this.initSearchTree();
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/knowledgeBase/KnowledgeCategoryPop.vue